// sensei-app/client/ui/ParentDashboard.js
import { ComponentBase } from "../../core/ComponentBase.js";

export class ParentDashboard extends ComponentBase {
    constructor(config) {
        super(config);
        this.dashboardComponent = null;
    }

    async initialize() {

        // Create the Dashboard component instance.
        // We set 'disableConfiguration' to true because this dashboard has a fixed layout.
        this.dashboardComponent = await this.createManagedComponent('Dashboard', null, {
            instanceId: `${this.config.instanceId}-parent-dashboard`,
            disableConfiguration: true, // This is a static, non-customizable dashboard
            resizableWidgets: true,
        });
        await super.initialize();

    }

    async initAfterLogin() {
        // This method is called after the user is logged in.
        // We define the static layout and apply it to our dashboard component.

        const predefinedLayout = [
            // Define the widgets that will appear on the parent's dashboard.
            {
                name: 'ChildsCourseProgressWidget',
                widgetId: 'parentCourseProgress',
                rows: 12, // Example size
                cols: 24  // Full width
            },
            // You can add more parent-specific widgets here in the future
            // For example:
            // { 
            //     name: 'UpcomingEventsWidget', 
            //     widgetId: 'parentUpcomingEvents', 
            //     rows: 10,
            //     cols: 12 
            // },
        ];

        // The dashboardComponent must be initialized before we can set its layout.
        if (this.dashboardComponent) {
            await this.dashboardComponent.setDashboardLayout(predefinedLayout);
        }
    }

    async render() {
        if (!this.container) {
            this.container = document.createElement('div');
            this.container.className = 'dashboard-container h-100'; // Ensure container takes full height
        }
        this.container.innerHTML = '';

        if (this.dashboardComponent) {
            const dashboardElement = await this.dashboardComponent.render();
            this.container.appendChild(dashboardElement);
        }

        this.appClient.tx.applyTranslations(this.container);
        return this.container;
    }

    destroy() {
        // The dashboardComponent is a managed component, so ComponentBase will handle its destruction.
        super.destroy();
    }
}